export default [
    {
        path: '/deal/pay',
        name: 'DealPay',
        component: () => import('@/pages/deal/pay/Pay.vue'),
        meta: {
            title: '支付设置',
            requireAuth: true,
            authority: 'deal:pay'
        },
        redirect: '/deal/pay/manage',
        children: [
            {
                path: 'manage',
                name: 'ManageList',
                component: () => import('@/pages/deal/pay/manage/List.vue'),
                meta: {
                    title: '微信商户号管理',
                    requireAuth: true,
                    authority: 'deal:pay'
                }
            },
            {
                path: 'apply',
                name: 'ApplyList',
                component: () => import('@/pages/deal/pay/apply/List.vue'),
                meta: {
                    title: '申请记录',
                    requireAuth: true,
                    authority: 'deal:pay'
                }
            },
        ]
    },
    {
        path: '/deal/pay/fill',
        name: 'DealPayFill',
        component: () => import('@/pages/deal/pay/progress/fill/Fill.vue'),
        meta: {
            title: '填写信息',
            requireAuth: true,
            authority: 'deal:pay'
        }
    },
    {
        path: '/deal/pay/details',
        name: 'DealPayDetails',
        component: () => import('@/pages/deal/pay/progress/fill/Details.vue'),
        meta: {
            title: '查看详情',
            requireAuth: true,
            authority: 'deal:pay'
        }
    },
    {
        path: '/deal/pay/verify',
        name: 'DealPayVerify',
        component: () => import('@/pages/deal/pay/progress/Verify.vue'),
        meta: {
            title: '账户验证',
            requireAuth: true,
            authority: 'deal:pay'
        }
    },
    {
        path: '/deal/pay/sign',
        name: 'DealPaySign',
        component: () => import('@/pages/deal/pay/progress/Sign.vue'),
        meta: {
            title: '签约',
            requireAuth: true,
            authority: 'deal:pay'
        }
    },
    {
        path: '/deal/order',
        name: 'DealOrderList',
        component: () => import('@/pages/deal/order/List.vue'),
        meta: {
            title: '订单管理',
            requireAuth: true,
            authority: 'deal:order'
        }
    },
    {
        path: '/deal/order/detail',
        name: 'DealOrderDetail',
        component: () => import('@/pages/deal/order/Detail.vue'),
        meta: {
            title: '查看详情',
            requireAuth: true,
            authority: 'deal:order'
        }
    },
    {
        path: '/deal/property',
        name: 'DealProperty',
        component: () => import('@/pages/deal/property/Property.vue'),
        meta: {
            title: '资产管理',
            requireAuth: true,
            authority: 'deal:property'
        },
        redirect: '/deal/property/withdraw',
        children: [
            {
                path: 'withdraw',
                name: 'WithdrawList',
                component: () => import('@/pages/deal/property/withdraw/List.vue'),
                meta: {
                    title: '提现管理',
                    requireAuth: true,
                    authority: 'deal:property'
                }
            },
        ]
    }
]


// WEBPACK FOOTER //
// ./src/router/module/deal.js